import { gsap } from 'gsap/all'
import { app } from '../appState'
import DeviceCheck from '../utils/deviceCheck'

export default class Tab {
  constructor() {
    this.deviceCheck = new DeviceCheck()
    this.tab = document.querySelector('.js-tab')
    this.tabBody = document.querySelector('.js-tab-body')

    if (!this.tab || !this.tabBody) {
      return
    }

    this.tabButtons = Array.from(this.tab.querySelectorAll('.js-tab-button'))
    this.tabContents = Array.from(this.tabBody.querySelectorAll('.js-tab-content'))
    this.isTab = 0
    this.init()
  }

  init() {
    this.setQueryParamToTabIndex()
    this.bindEvent()
  }

  getQueryParams() {
    return Object.fromEntries(new URLSearchParams(window.location.search).entries())
  }

  setQueryParamToTabIndex() {
    const queryParams = this.getQueryParams()
    const tabIndex = parseInt(queryParams.tab, 10) - 1

    if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < this.tabContents.length) {
      this.isTab = tabIndex
    }

    this.switchTab(this.isTab)
  }

  bindEvent() {
    this.tabButtons.forEach((el, i) => {
      el.addEventListener('click', (e) => {
        const url = new URL(window.location.href)
        url.searchParams.set('tab', i + 1)
        history.pushState(null, '', url)

        this.switchTab(i)

        if (e.currentTarget.dataset.scroll !== 'false') {
          this.scroll()
        }
      })
    })

    window.addEventListener('popstate', () => {
      this.setQueryParamToTabIndex()
    })
  }

  setCurrentButton(i) {
    this.tab.querySelectorAll('.is-current').forEach((el) => {
      el.classList.remove('is-current')
    })

    const button = this.tabButtons[i]
    if (button) {
      button.classList.add('is-current')
    }
  }

  switchTab(i) {
    const targetContent = this.tabContents[i]
    if (!targetContent) {
      return
    }

    this.setCurrentButton(i)

    const currentContent = this.tabBody.querySelector('.is-show')

    if (currentContent === targetContent) {
      return
    }

    if (currentContent) {
      currentContent.classList.remove('is-show')
      gsap.set(currentContent, { autoAlpha: 0, display: 'none' })
    }

    targetContent.classList.add('is-show')
    gsap.set(targetContent, { autoAlpha: 0, display: 'block' })
    gsap.to(targetContent, { autoAlpha: 1, delay: 0.1, duration: 0.6, ease: 'power3.out' })
  }

  scroll() {
    const offsetH = this.deviceCheck.getDeviceSize() === 'mobile' ? 60 : 120
    const targetTop = Math.max(0, this.tab.getBoundingClientRect().top + window.pageYOffset - offsetH)
    const lenis = app.Root?.lenis

    gsap.killTweensOf(window)

    if (lenis) {
      lenis.scrollTo(targetTop, { duration: 0.6, lock: true, programmatic: true })
      return
    }

    gsap.to(window, { duration: 0.6, scrollTo: { y: targetTop, autoKill: false }, ease: 'power2.inOut' })
  }
}
